import 'react-multi-carousel/lib/styles.css';
import background from "../assets/img/color-sharp.png"
import java from "../assets/img/java.png"
import spring from "../assets/img/spring.png"
import post from "../assets/img/postgres.png"
import html from "../assets/img/html.png"
import css from "../assets/img/css.png"
import django from "../assets/img/django.png"
import git from "../assets/img/giticon.png"
import github from "../assets/img/githubicon.png"
import js from "../assets/img/js.png"
import react from "../assets/img/react.png"
import bs from "../assets/img/bootstrap.png"
import docker from "../assets/img/docker.png"
import mongo from "../assets/img/mongo.png"
import node from "../assets/img/node.png"
import python from "../assets/img/python.png"
import heroku from "../assets/img/Heroku.png"
import jest from "../assets/img/jest.webp"
import express from "../assets/img/express.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                  <h2>Skills</h2>
                    <div className="skill-box">
                      
                        <div className="icons-div">
              <a
                href="https://www.java.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={java} alt="java-icon" />
              </a>
              <p className="skills-name">Java</p>
            </div>

             {/* HTML */}
             <div className="icons-div">
              <a
                href="https://html.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={html} alt="html-icon" />
              </a>
              <p className="skills-name">HTML5</p>
            </div>
            {/* CSS */}
            <div className="icons-div">
              <a
                href="https://developer.mozilla.org/en-US/docs/Web/CSS"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={css} alt="css-icon" className="css-icon" />
              </a>
              <p className="skills-name">CSS</p>
            </div>
            {/* Javascript */}
            <div className="icons-div">
              <a
                href="https://www.javascript.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={js} alt="javascript-icon" />
              </a>
              <p className="skills-name">Javascript</p>
            </div>
            {/* React */}
            <div className="icons-div">
              <a
                href="https://reactjs.org/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={react} alt="react-icon" />
              </a>
              <p className="skills-name">React</p>
            </div>
            {/* Bootstrap */}
            <div className="icons-div">
              <a
                href="https://getbootstrap.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={bs} alt="bootstrap-icon"
                />
              </a>
              <p className="skills-name">Bootstrap</p>
            </div>
            {/* Nodejs */}
            <div className="icons-div">
              <a
                href="https://nodejs.org/en/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={node} alt="node-icon"/>
              </a>
              <p className="skills-name">NodeJS</p>
            </div>
            {/* Mongo */}
            <div className="icons-div">
              <a
                href="https://www.mongodb.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={mongo}
                  alt="mongodb-icon"
                />
              </a>
              <p className="skills-name">MongoDB</p>
            </div>
            {/* Postgresql */}

            <div className="icons-div">
              <a
                href="https://www.postgresql.org/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={post}
                  alt="postgres-icon"
                />
              </a>
              <p className="skills-name">PostgreSQL</p>
            </div>
            </div>
            <div className="skill-box">
            {/* Express */}
            <div className="icons-div">
              <a
                href="https://expressjs.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={express}
                  alt="express-icon"
                />
              </a>
              <p className="skills-name">Express</p>
              {/* Django */}
            </div>
            <div className="icons-div">
              <a
                href="https://www.djangoproject.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src= {django}
                  alt="django-icon"
                />
              </a>
              <p className="skills-name">Django</p>
            </div>
            {/* Python */}
            <div className="icons-div">
              <a
                href="https://www.python.org/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={python}
                  alt="python-icon"
                />
              </a>
              <p className="skills-name">Python</p>
            </div>
           {/* Heroku */}
            <div className="icons-div">
              <a
                href="https://www.heroku.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={heroku} alt="heroku-icon"/>
              </a>
              <p className="skills-name">Heroku</p>
            </div>
            <div className="icons-div">
              <a
                href="https://Docker.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={docker} alt="docker-icon"/>
              </a>
              <p className="skills-name">Docker</p>
            </div>
            <div className="icons-div">
              <a
                href="https://jestjs.io/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={jest}
                  alt="jest-icon"
                />
              </a>
              <p className="skills-name"> Jest</p>
            </div>
            {/* Git */}
            <div className="icons-div">
              <a
                href="https://git-scm.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={git} alt="git-icon"/>
              </a>
              <p className="skills-name">Git</p>
            </div> 
            {/* github */}
            <div className="icons-div">
              <a
                href="https://github.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={github} alt="github-icon"
                />
              </a>
              <p className="skills-name">GitHub</p>
            </div>
            
            {/*  Spring boot*/}
            <div className="icons-div">
              <a
                href="https://spring.io/projects/spring-boot"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={spring} alt="spring-icon"/>
              </a>
              <p className="skills-name">Spring Boot</p>
            </div> 
            </div>        
                
                </div>
            </div>
        </div>
        <img className="background-image-left" src={background} alt="background" />
    </section>
  )
}
